import { render } from "./InputTagSelect.vue?vue&type=template&id=640f1dc0"
import script from "./InputTagSelect.vue?vue&type=script&lang=js"
export * from "./InputTagSelect.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__